import { render } from "./ViewBrokerage.vue?vue&type=template&id=2bddd8c6&scoped=true"
import script from "./ViewBrokerage.vue?vue&type=script&lang=js"
export * from "./ViewBrokerage.vue?vue&type=script&lang=js"

import "./ViewBrokerage.vue?vue&type=style&index=0&id=2bddd8c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bddd8c6"]])

export default __exports__